import { Outlet } from "react-router-dom";
import Navbar from "../pages/navbar/navbar";
import Footer from "../components/footer";
import { Box } from "@mui/material";

function RootLayout() {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      {/* Fixed height Navbar */}
      <Box sx={{ height: "64px", flexShrink: 0 }}>
        <Navbar />
      </Box>

      {/* Main content takes remaining space */}
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        <Outlet />
      </Box>

      {/* Fixed height Footer */}
      <Box sx={{ height: "80px", flexShrink: 0 }}>
        <Footer />
      </Box>
    </Box>
  );
}

export default RootLayout;
